var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.6 12.34A3.57 3.57 0 0 1 1 8.79v0a3.57 3.57 0 0 1 3.84-3.54A4.81 4.81 0 0 1 9 2.88c2.4 0 4.38 1.72 4.74 3.98A2.78 2.78 0 0 1 17 9.58a2.78 2.78 0 0 1-2.8 2.76M9.37 7.44v5.62",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6.82 9.43 2.55-2.19 2.54 2.19",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCloudUpload;